/*
 * @Author: fz
 * @Date: 2021-07-29 10:15:22
 * @LastEditTime: 2021-09-24 09:50:50
 * @LastEditors: Please set LastEditors
 * @Description: 电子路书排班管理 -- api
 */
import http from "e6-base-core/axios/config";
import { e6ModuleOrderWaybillProcessApi } from "@/config/api";
const {
  host = "",
  //   E6_MS_TMS_BUSI_WEB = "",
  E6_MS_TMS_BASE_WEB = "", // 其他相关接口
  E6_MS_TMS_E6YUN_BASE_WEB // 司机下拉
} = e6ModuleOrderWaybillProcessApi;

// const mockUrl =
//   "http://easymock.dev.e6gpshk.com:30081/mock/607633b7ab29eb0020907576/e6-base-data-test";

// 获取表格列
// export function getColumn(sceneGroupId) {
//   return http({
//     url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/tms/field/getColumn/${sceneGroupId}`,
//     method: "get"
//   });
// }
// 获取查询条件扩展字段
// export function getExtendFields(sceneGroupId) {
//   return http({
//     url: `${host}${mockUrl}/tms/field/getExtendSearchInfo/${sceneGroupId}`,
//     method: "get"
//   });
// }
//获取新增下拉司机列表
export function getEditDriver(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/drivers/findAllDriverByPage`,
    method: "post",
    data
  });
}

//获取列表数据
export function listRoadBooksByPage(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/fixedLineScheduling/listByPage`,
    method: "post",
    data
  });
}

//获取历史列表数据
export function listHistoryRoadBooksByPage(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/fixedLineScheduling/listHistoryByPage`,
    method: "post",
    data
  });
}

//根据id获取数据
export function findRoadBookById(params) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/fixedLineScheduling/findById`,
    method: "get",
    params
  });
}

//弹框 -- 保存
export function saveRoadBook(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/fixedLineScheduling/save`,
    method: "post",
    data
  });
}

//删除
export function deleteRoadBooksByIds(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/fixedLineScheduling/deleteByIds`,
    method: "post",
    data
  });
}

//导出数据
export function exportFixedLineScheduling(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/fixedLineScheduling/exportFixedLineScheduling`,
    method: "post",
    responseType: "blob",
    headers: { "Content-Type": "application/json" },
    data
  });
}
